module.exports = __webpack_public_path__ + "static/the-end-a353bda6721a63c52378918fd248f568.svg";